import React, { PropsWithChildren, useState } from 'react';
import styled, { useTheme } from 'styled-components';
import { Icon, IconType } from '@components';
import { ITheme } from '../../interfaces/styled';

export type LinkProps = PropsWithChildren<{
  href?: string;
  icon?: IconType;
  title?: string;
  target?: '_self' | '_blank' | '_parent' | '_top'
  onClick?: () => void;
}>;

const StyledLink = styled.a`
  display: inline-flex;
  align-items: center;
  column-gap: 8px;
  font-size: ${({ theme }) => theme.fontSize.xs}px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.textMoreTransparency};
  text-decoration: none;
  transition: 0.3s ease-out;
  
  &:hover {
    color: ${({ theme }) => theme.colors.text};
  }
`;

const Link: React.FC<LinkProps> = (props) => {
  const {
    icon,
    href,
    target,
    title,
    onClick,
    children
  } = props;
  
  const globalTheme = useTheme() as ITheme;
  const [ iconColor, setIconColor ] = useState(globalTheme.colors.textMoreTransparency);
  
  return (
    <StyledLink
      href={href}
      target={target}
      title={title}
      onMouseOver={() => setIconColor(globalTheme.colors.text)}
      onMouseOut={() => setIconColor(globalTheme.colors.textMoreTransparency)}
      onClick={onClick}
    >
      { icon && <Icon glyph={icon} size={20} color={iconColor} /> }
      {children}
    </StyledLink>
  );
};

export { Link };
